// Mobile drawer
var ham=document.getElementById('hamburger'),drawer=document.getElementById('mobile-drawer'),overlay=document.getElementById('drawer-overlay'),dc=document.getElementById('drawer-close');
function openDrawer(){if(drawer)drawer.classList.add('open');if(overlay)overlay.classList.add('show')}
function closeDrawer(){if(drawer)drawer.classList.remove('open');if(overlay)overlay.classList.remove('show')}
if(ham)ham.addEventListener('click',openDrawer);
if(dc)dc.addEventListener('click',closeDrawer);
if(overlay)overlay.addEventListener('click',closeDrawer);

// Cart count
function refreshCart(){fetch('/cart.js').then(r=>r.json()).then(function(c){var el=document.getElementById('cart-count');if(el)el.textContent=c.item_count})}

// AJAX add to cart
document.addEventListener('submit',function(e){
  var f=e.target;
  if(!f.classList.contains('atc-form'))return;
  e.preventDefault();
  var btn=f.querySelector('.atc');
  var orig=btn.textContent;
  btn.textContent='Adding...';
  btn.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:new URLSearchParams(new FormData(f))})
  .then(function(r){return r.json()})
  .then(function(){btn.textContent='Added ✓';refreshCart();setTimeout(function(){btn.textContent=orig;btn.disabled=false},2000)})
  .catch(function(){btn.textContent=orig;btn.disabled=false});
});
